import React from 'react';
import './App.css';
import SearchPage from './SearchPage';
import Header from './component/Header';
import Footer from './component/Footer';

import { Container } from '@mui/material';

function App() {
  return (
    <div className="App">
      <Header />
      <Container maxWidth="xl" className="pagewrapper">
        <SearchPage />
      </Container>
      <Footer />
    </div>
  );
}

export default App;
